import React, { useState, useCallback, useRef, useEffect } from 'react';
import {useHistory} from 'react-router-dom';
import { inject } from 'mobx-react';
import {toast} from 'react-toastify';
import { ManageAlbumsGrid } from './mng-albums-grid';
import { ManageSongGrid } from '../mng-songs/mng-song-grid';
import { MusicPlayer } from '../music-player';

const ManageAlbums = ({albumsStore, artistStore}) => {
    const [albumItems, setAlbumItems] = useState([]);
    const [currentAlbum, setCurrentAlbum] = useState(null);
    useEffect(() => {
        const fetchData = async () => {
            await albumsStore.fetchItems();
            setAlbumItems(albumsStore.items)
        }
        fetchData()
    }, []);

    return (
        <div>
            <div className="grid-x padding-top-1 padding-left-1">
                <div className="cell auto">
                    <h3 data-ta="mngAlbumsHeader">Manage Albums</h3>
                </div>
            </div>
            {!currentAlbum && (<ManageAlbumsGrid dataSource={albumItems} artistStore={artistStore} onRowClick={(rowData) => {
                setCurrentAlbum(rowData);
            }} />)}
            {currentAlbum && (
                <div className="grid-x padding-top-1 padding-left-1">
                    <div className="cell auto">
                        <h5 data-ta="mngAlbumsHeader">Album Details</h5>
                        <button className="button neo small" onClick={() => setCurrentAlbum(null)}>Back to Album List</button>
                        <h6><strong>Album Name:</strong> {currentAlbum.name}</h6>
                        <h6><strong>Album Artist:</strong> {artistStore.items.find(item => item.id === currentAlbum.artistId)?.name || 'Unknown Artist'}</h6>

                        <h6>Track List</h6>
                        <ManageSongGrid dataSource={currentAlbum.songs} />

                    </div>
                    <MusicPlayer />
                </div>
            )}
        </div>
    )
}

const injectWithStores = inject('albumsStore', 'artistStore');

export default injectWithStores(
    ({albumsStore, artistStore}) => {
        return (
            <ManageAlbums albumsStore={albumsStore} artistStore={artistStore}/>
        )
})